<template>
    <h1>Create an account</h1>
    <p>
        <input type="text" placeholder="Email" v-model="email"/>
    </p>
    <p>
        <input type="password" placeholder="Password" v-model="password"/>
    </p>
    <p>
        <button @click="register">Sign Up</button>
    </p>
    <p>
        <button @click="signInWithGoogle">Sign In With Google</button>
    </p>
</template>
<script setup>
import { ref } from "vue";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
const email = ref("");
const password = ref("");

const register = () => {
    createUserWithEmailAndPassword(getAuth(), email.value, password.value)
    .then(()=>{
        console.log("Registered!")
    })
    .catch(()=>{
        console.log("Fail")
    })
}

const signInWithGoogle = () => {


}
</script>